function accordionAnchorExpand(): void {
  let anchor = window.location.hash.replace('#', '');
  if (anchor) {
    let anchorElement = document.getElementById(anchor);
    if (anchorElement) {
      let accordionCollapsedButton = anchorElement.querySelector<HTMLElement>('.accordion-button.collapsed');
      if (accordionCollapsedButton) {
        accordionCollapsedButton.click();
        setTimeout(
          function() { anchorElement.scrollIntoView(true) },
          300
        );
      }
    }
  }
}

function accordionAnchorSet(): void {
  let accordionHeaders = document.querySelectorAll('.accordion-header');
  accordionHeaders.forEach(accordionHeader => {
    let accordionButton = accordionHeader.querySelector<HTMLElement>('.accordion-button');
    if (accordionButton) {
      accordionButton.addEventListener('click', event => {
        window.location.hash = accordionHeader.id;
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  accordionAnchorExpand();
  accordionAnchorSet();
});
